import React, { useState } from "react";
import "./custom.layout.dropdown.scss";
import { ThemedIcon } from "@me8eon/icons";
import { SimpleOutsideClick } from "@me8eon/outside_click";

type CustomLayoutDropdownProps = {
    iconName?: string;
    name: string;
    isScrollY?: boolean;
    layout: (props: {
        isOpen: boolean;
        onClose: () => void;
    }) => React.ReactNode;
};

export const CustomLayoutDropdown = ({
    iconName,
    name,
    layout,
    isScrollY,
}: CustomLayoutDropdownProps) => {
    const [isOpen, setIsOpen] = useState(false);

    const handleClose = () => setIsOpen(false);
    const handleToggle = () => setIsOpen((prev) => !prev);

    return (
        <SimpleOutsideClick onClickOutside={handleClose}>
            <div className="custom-layout-dropdown">
                <button
                    type="button"
                    className={`custom-layout-dropdown__button ${isOpen ? 'active' : ''}`}
                    onClick={handleToggle}
                >
                    <ThemedIcon name={iconName ?? ""} /><span className="custom-layout-dropdown__name" style={{ fontSize: isScrollY ? "14px" : "18px" }}>{name}</span>
                </button>
                <div className="custom-layout-dropdown__content">
                    {layout({
                        isOpen,
                        onClose: handleClose,
                    } as any)}
                </div>
            </div>
        </SimpleOutsideClick>
    );
};
